import React from "react";

interface ButtonProps {
    id: number;
    type: string;
    label: string;
    icon: any;
    className?: string;
    tooltip?: string;

}

interface ButtonGroupProps {
    buttonOptions: ButtonProps[];
    handleClick: any;
    disabled?: boolean;
    className?: string;
    tooltip?: string;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({
    buttonOptions,
    handleClick,
    disabled,
    className = ''
}) => {
    return (
        <div className={`flex justify-center items-center gap-[12px] ${className}`}>
            {buttonOptions?.map((option) => (
                <div
                    className={`flex gap-[8px] px-2 py-2 justify-center items-center rounded-[8px] ${option?.type === "primary"
                        ? `border-rgba(255, 255, 255, 0.12) bg-primary-500 text-sm font-bold hover:border-primary-600 shadow-custom ${disabled ? "opacity-50 bg-darkcolor-700 border-darkcolor-700 text-darkcolor-300 cursor-not-allowed" : "text-white border-rgba(255, 255, 255, 0.12) bg-primary-500 hover:bg-primary-600 active:text-[#FCFCFD] cursor-pointer"
                        }`
                        : "border-[1px] border-darkcolor-400 text-sm font-normal border-solid hover:bg-darkcolor-500 hover:border-darkcolor-300"
                        } ${option.className}`}
                    key={option?.label}
                    onClick={() => !disabled && handleClick(option)}
                    title={option.tooltip}
                >
                    {option?.icon}
                    <button
                        className={`flex justify-center items-center text-neutral-25 ${disabled ? 'cursor-not-allowed' : 'pointer'}`}
                        disabled={disabled}
                        title={option.tooltip}
                    >
                        {option?.label}
                    </button>
                </div>
            ))}
        </div>
    );
};

export default ButtonGroup;
